import api from '../api';

export const getSettings = async workspaceId => {
  return api.get(`/v0/user/${workspaceId}/settings`).then(({ data }) => data);
};

export const getSettingsByKey = async key => {
  return api
    .get(`/v0/settings`, { headers: { key: key } })
    .then(({ data }) => data);
};

export const saveSettings = async (payload, workspaceId) => {
  return api
    .patch(`/v0/user/${workspaceId}/settings`, payload)
    .then(({ data }) => data);
};
